(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stringer-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-hero-slideshow')) {
    customElements.define('sm-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.dots = [...this.querySelectorAll('[data-slide-to]')];
        this.current = Math.max(0, this.slides.findIndex((slide) => slide.hasAttribute('data-active')));
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = Number(this.dataset.interval) || 6000;
        this.pausedByUser = false;
        this.holdReasons = new Set();
        this.abortController = new AbortController();
        this.bindEvents();
        this.show(this.current, false);
        this.classList.add('is-ready');
        this.start();
      }

      disconnectedCallback() { this.stop(); this.abortController?.abort(); }

      bindEvents() {
        const signal = this.abortController.signal;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1), { signal });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.slideTo)), { signal }));
        this.querySelector('[data-pause]')?.addEventListener('click', () => this.togglePause(), { signal });
        this.addEventListener('mouseenter', () => this.hold('hover'), { signal });
        this.addEventListener('mouseleave', () => this.release('hover'), { signal });
        this.addEventListener('focusin', () => this.hold('focus'), { signal });
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.release('focus'); }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.current - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.current + 1); }
        }, { signal });
        this.addEventListener('pointerdown', (event) => { this.pointerStart = event.clientX; }, { signal });
        this.addEventListener('pointerup', (event) => {
          if (this.pointerStart == null) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = null;
          if (Math.abs(distance) > 50) this.show(this.current + (distance < 0 ? 1 : -1));
        }, { signal });
        document.addEventListener('visibilitychange', () => document.hidden ? this.hold('hidden') : this.release('hidden'), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.hold('editor'); this.show(index, false); }
        }, { signal });
        document.addEventListener('shopify:block:deselect', () => this.release('editor'), { signal });
      }

      show(index, announce = true) {
        if (this.slides.length < 1) return;
        const next = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          slide.toggleAttribute('data-active', position === next);
          slide.toggleAttribute('data-before', position < next);
          slide.setAttribute('aria-hidden', position === next ? 'false' : 'true');
          slide.querySelectorAll('a, button').forEach((control) => position === next ? control.removeAttribute('tabindex') : control.setAttribute('tabindex', '-1'));
        });
        this.dots.forEach((dot, position) => position === next ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        this.current = next;
        if (announce) {
          const heading = this.slides[next].querySelector('[data-slide-heading]')?.textContent?.trim() || '';
          this.querySelector('[data-announcer]').textContent = `Slide ${next + 1} of ${this.slides.length}. ${heading}`;
        }
        this.start();
      }

      hold(reason) { this.holdReasons.add(reason); this.stop(); }
      release(reason) { this.holdReasons.delete(reason); this.start(); }
      stop() { clearTimeout(this.timer); }
      start() {
        this.stop();
        if (!this.autoplayEnabled || this.pausedByUser || this.holdReasons.size) return;
        this.timer = setTimeout(() => this.show(this.current + 1, false), this.interval);
      }
      togglePause() {
        this.pausedByUser = !this.pausedByUser;
        const button = this.querySelector('[data-pause]');
        button.setAttribute('aria-label', this.pausedByUser ? 'Play slideshow' : 'Pause slideshow');
        button.querySelector('span').textContent = this.pausedByUser ? '▶' : 'Ⅱ';
        this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
